import React, { useState } from "react";
import styled from "styled-components";
import DotLoader from "react-spinners/DotLoader";

const ContenidoDiv = styled.div`
  text-align: center;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    h2 {
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
`;
const IframeForms = styled.iframe`
  margin-top: 10px;
  width: 700px;
  height: 140rem;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 380px;
  }
`;
const ContenedorSpin = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30vh;
  gap: 10px;
`;

const RegistroGodoyCruz = () => {
  const [loading, setLoading] = useState(true);
  return (
    <ContenidoDiv>
      <h4>Viajes Inferiores GC</h4>
      <h5>Registro de viajes Facturados</h5>

      {loading && (
        <ContenedorSpin>
          <DotLoader color="#c20000" size={40} />
          <p>Cargando formulario, por favor espera...</p>
        </ContenedorSpin>
      )}

      <IframeForms
        title="Registro de viajes Facturados"
        src="https://docs.google.com/forms/d/e/1FAIpQLScW-850NhGoKgBME-0BPOxYaTtmuGH14pzc_zZqRIYyBsvdGg/viewform?embedded=true"
        width="420"
        height="520"
        onLoad={() => setLoading(false)}
      ></IframeForms>
    </ContenidoDiv>
  );
};

export default RegistroGodoyCruz;
